import logo from 'assets/integrations/slack/logo.svg';

export default {
  slug: 'slack',
  name: 'Slack',
  summary: 'Unfold Optera.io links in slack messages.',
  logo: logo
};
